import React, { createContext, useContext, useEffect, useState } from "react";

interface TableContextType {
  tableId: string | null;
  setTable: (id: string | null) => void;
}

const TableContext = createContext<TableContextType | undefined>(undefined);

export const TableProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tableId, setTableIdState] = useState<string | null>(() =>
    sessionStorage.getItem("tableId")
  );

  useEffect(() => {
    const hash = window.location.hash;

    if (hash && hash.includes("table=")) {
      const match = hash.match(/table=([^&]+)/);
      if (match && match[1]) {
        const value = decodeURIComponent(match[1]);
        sessionStorage.setItem("tableId", value);
        setTableIdState(value);
      }

      // امسح الهاش من الرابط بعد استخراج رقم الطاولة
      window.history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
      );
    }
  }, []);

  const setTable = (id: string | null) => {
    if (!id) {
      sessionStorage.removeItem("tableId");
      setTableIdState(null);
    } else {
      sessionStorage.setItem("tableId", id);
      setTableIdState(id);
    }
  };

  return (
    <TableContext.Provider value={{ tableId, setTable }}>
      {children}
    </TableContext.Provider>
  );
};

export function useTable(): TableContextType {
  const context = useContext(TableContext);
  if (!context) throw new Error("useTable must be used inside TableProvider");
  return context;
}
